// extracted by mini-css-extract-plugin
module.exports = {"timeline":"timeline-module--timeline--1DgK1","isLive":"timeline-module--is-live--bzJll"};